'use client'

import React from 'react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { SessionProvider } from 'next-auth/react'
import { NuqsAdapter } from 'nuqs/adapters/next/app'

import { BarcodeReader } from '@/components/molecules'
import { LoaderProvider } from '@/components/providers/loader-provider'
import { ModalProvider } from '@/components/providers/modal-provider'
import { PermissionsProvider } from '@/components/providers/permissions-provider'
import { RefProvider } from '@/components/providers/ref-provider'
import { StoreProvider } from '@/components/providers/store-provider'
import { Toaster, TooltipProvider } from '@/components/ui'

export function Providers({ children }: { children: React.ReactNode }) {
  const [queryClient] = React.useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 60 * 1000,
            refetchOnWindowFocus: false,
          },
        },
      }),
  )

  return (
    <SessionProvider>
      <NuqsAdapter>
        <StoreProvider>
          <QueryClientProvider client={queryClient}>
            <RefProvider>
              <PermissionsProvider>
                <ModalProvider>
                  <TooltipProvider delayDuration={10}>{children}</TooltipProvider>
                </ModalProvider>
              </PermissionsProvider>
              <Toaster
                className="hidden lg:block"
                position="top-right"
                richColors
                duration={4000}
                theme="light"
              />
              <Toaster
                className="lg:hidden"
                position="bottom-right"
                richColors
                duration={4000}
                theme="light"
              />
              <LoaderProvider />
              <BarcodeReader />
            </RefProvider>
            <ReactQueryDevtools initialIsOpen={false} />
          </QueryClientProvider>
        </StoreProvider>
      </NuqsAdapter>
    </SessionProvider>
  )
}
